module.exports = __webpack_public_path__ + "static/media/comment.93591472.svg";